// extracted by mini-css-extract-plugin
export default {"videoContainer":"video_videoContainer__xUFwB","video":"video_video__ivRXr"};